import React from 'react';
import {BrowserRouter,Routes,Route} from 'react-router-dom';
import Portfolio from './portfolio/Portfolio';
import Pagenot  from './Pagenot/Pagenotfound';
import Freepro  from './FreePro/Freepro';
const App = () => {
  return (
   <>
      <BrowserRouter>
      <Routes>
        <Route path='/' element={<Portfolio/>}/>
        <Route path='/FreePro' element={<Freepro/>}/>
        <Route path='*' element={<Pagenot/>}/>
      </Routes>
      </BrowserRouter>
   </>
  )
}
export default App;